import type { ActionContext } from 'vuex'

import type { ActionClass, MediaState } from '../../../models'

import { MEDIA_CONSTS } from '../../../store/media/media.consts'

export class SetViewportWidthAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<MediaState, any>,
    viewportWidth: number,
  ): void {
    commit(MEDIA_CONSTS.mutations.setViewportWidth, viewportWidth)
  }
}
